import { ScopeMode } from '@/client/custom-roles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type ScopeModeExplainerProps = {
  mode: ScopeMode;
  className?: string;
};

const Explainer = styled.p`
  margin: 0;
  padding: var(--small-padding) var(--xsmall-padding);
  background-color: var(--white-main);
  border: 1px solid var(--gray-dark);
  border-radius: var(--xsmall-border-radius);
  font-size: var(--xsmall-font-size);
  font-weight: var(--regular-font-weight);
  line-height: var(--xsmall-line-height);
`;

const Term = styled.span`
  font-weight: var(--medium-font-weight);
`;

export const ScopeModeExplainer: React.FC<ScopeModeExplainerProps> = ({
  mode,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Explainer className={className}>
      <Term>{t(`account.rolesAccess.scopeMode.${mode}`)}:</Term>{' '}
      {t(`account.rolesAccess.builder.scope.explainer.${mode}`)}
    </Explainer>
  );
};
